(ns teamoesterreich.admin-mode.toe-map-search.toe-map-search
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.webSelection :as d-webSelection]
            [teamoesterreich.admin-mode.detail-filter.detail-filter-form :as filter-form]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.icons.search :refer [search]]
            [reagent-material-ui.icons.cancel :refer [cancel]]
            [reagent-material-ui.icons.alternate-email :refer [alternate-email]]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.toe-map-search.maps-element :as maps-element]
            [teamoesterreich.admin-mode.toe-map-search.small-toe-table :as small-toe-table]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.check-box-two-tone :refer [check-box-two-tone]]
            [reagent.core :as r]))

(defn event-value
  [^js/Event e]
  (h/event-value e))



(defn update-list [!st !address-marker !search !filter]
  (js/console.log "update-list " @!search @!filter)
  (d-user/get-user-list-elements
    (merge {:srch-add-fields {:tomId true :name true :email true :phone true :geo true}
            :sort sort
            :center-lat (:lat @!address-marker)
            :center-lng (:lng @!address-marker)
            :center-radius (int (or (:radius @!address-marker) "5000"))
            }
           (filter-form/get-filter-request-part-noAddFields !search !filter)
           )

    (fn [data]
      (swap! !st assoc
             :loaded true
             :ids (get data "ids")
             :count (get data "cnt")
             :elems (get data "rows")))
    ))






(defn filter-fn [elms search lat lng &[filterNachbar]]
  (into {} (filter (fn [[k e]]
                     (and
                       (re-find
                         (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
                         (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e)))
                       (or (nil? lat)
                           (and
                             (< (abs (- lat (:user-addressLatitude e))) 0.015)
                             (< (abs (- lng (:user-addressLongitude e))) 0.030)))

                       (or (not filterNachbar) (:user-helpingNormNachbarschaftshilfe e) (:user-helpingKatNachbarschaftshilfe e))
                       ))
                   elms)))

(defn get-sort-filter-rows [elms sort_ reverse_]
  ;(js/console.log "res = "  (first rows))
  (let [rows (if elms (mapv (fn [[k v]] (assoc v :index k)) elms) [])
        rows (sort-by (keyword (if sort_ sort_ :user-lastName)) rows)
        rows (if reverse_ (reverse rows) rows)]
    rows))


(defn selected-chip [!st]
  (let [!st-selected (r/cursor !st [:selected])
        !selection-uuid (r/cursor vstate/app-state [:selected-elements :list-uuid])
        !selection-loaded (r/cursor vstate/app-state [:selected-elements :loaded])
        !selectionLists-loaded (r/cursor vstate/app-state [:selected-elements :lists-loaded])]
    [mui/chip {:style     {:verticalAlign "center" :margin "0px 0 7px 0"}
               :color     "primary"
               :clickable "true"
               :icon (r/as-element [add])
               :title     "Zur aktuellen Auswahl hinzufügen"
               :label     (str (count (filter second @!st-selected)) " Einträge zur Auswahl hinzufügen")
               :onClick   (fn [] (d-webSelection/>add-user @!selection-uuid (mapv first (filter second @!st-selected))
                                                           (fn []
                                                             (reset! !st-selected {})
                                                             (reset! !selectionLists-loaded false)
                                                             (reset! !selection-loaded false))))
               }]
    ))


(defn select-all [!st allIds]
  (let [!selected (r/cursor !st [:selected])]
    [mui/icon-button
     {:title   "Alle auswählen"
      :onClick (fn []
                 (log/debug "count all " (count allIds))
                 (let [selUnSel (not (= (count (filter second @!selected)) (count allIds)))
                       res (into {} (map (fn [e] [e selUnSel]) allIds))]
                   (reset! !selected res)
                   ))}
     [check-box-two-tone]]
    ))


(defn render [!st !loaded?]
  (let [!elems (r/cursor !st [:elems])
        !search (r/cursor !st [:search])
        !filter (r/cursor !st [:filter])
        !center-map (r/cursor !st [:center-map])
        !address-marker (r/cursor !st [:address-marker])
        !ids (r/cursor !st [:ids])
        !count (r/cursor !st [:count])
        !map-userPopup (r/cursor vstate/app-state [:toe-map :activeUserPopup])
        !map-ac  (r/cursor vstate/app-state [:toe-map :autoCompleteObj])
        !autoCompleteObj (r/cursor !st [:autoCompleteObj])
        all @!ids
        ]
    (js/console.log "Mount toe-map-list " (:formatted_address @!map-ac) @!elems)
    (let [cnt-rows @!count]
      ;(println "filtered rows count " cnt-rows)

      [mui/grid
       {:container true
        :direction "row"
        :spacing 1
        :style {:marginTop "15px"}
        }
       [mui/grid
        {:item  true
         :lg    12
         :xs    12
         :style {:padding "15px"}
         }
        [filter-form/filter-form !st false]
        ]
       ;;map site
       [mui/grid
        {:item true
         :lg 9
         :md 7
         :xs 12}
        [toe-modal/get-modal !map-userPopup]


        [mui/paper {:style {:marginBottom "7px" :marginLeft "10px" :padding "10px 5px 5px 5px"}}
         [mui/grid
          {:container true
           :direction "row"
           :spacing 1
           :alignItems "flex-end"
           }


          ;;map search
          [mui/grid
           {:item true
            :lg 6
            :xs 8
            }


           [mui/text-field
            {
             :id "google-Autocomplete"
             :label       "Adressensuche"
             :placeholder "suche..."
             :fullWidth true
             :default-value (:formatted_address @!map-ac)
             :multiline   false}]]

          [mui/grid
           {:item true
            :lg 2
            :xs 4
            }
           [mui/form-control
            {
             :fullWidth true
             }
            [mui/input-label "Radius "]
            [mui/select
             {:multiple false
              :value (or (get-in @!address-marker [:radius]) "5000")
              :onChange (fn [val]
                          (log/debug "Set :onChange " (event-value val) )
                          (swap! !address-marker assoc :radius (event-value val))
                          )
              }
             [mui/menu-item {:value "500"} "500m"]
             [mui/menu-item {:value "1000"} "1km"]
             [mui/menu-item {:value "2000"} "2km"]
             [mui/menu-item {:value "5000"} "5km"]
             [mui/menu-item {:value "10000"} "10km"]
             [mui/menu-item {:value "15000"} "15km"]
             [mui/menu-item {:value "20000"} "20km"]
             [mui/menu-item {:value "50000"} "50km"]
             [mui/menu-item {:value "100000"} "100km"]
             [mui/menu-item {:value "200000"} "200km"]
             ]]]

          [mui/grid
           {:item true
            :lg 2
            :xs 6
            :align-items "flex-start"
            }
           [mui/button
            {:variant  "outlined"
             :color    "primary"
             :on-click (fn []
                         (when-let [ac @!autoCompleteObj]
                           (when-let [place (.getPlace ac)]
                             (when-let [geo (.-geometry place)]
                               (let [center {:zoom 11 :lat (.lat (.-location geo)) :lng (.lng (.-location geo))}]
                                 (log/debug "Set address " (.lat (.-location geo)) (.lng (.-location geo)))
                                 (reset! !address-marker {:radius (or (:radius @!address-marker) "5000") :lat (.lat (.-location geo)) :lng (.lng (.-location geo))})
                                 (reset! !center-map center)
                                 (update-list !st !address-marker !search !filter)
                                 )))))
             }
            "Suchen"
            [search]]]


          [mui/grid
           {:item true
            :lg 2
            :xs 6
            :align-items "flex-start"
            }
           [mui/button
            {:variant  "outlined"
             :color    "secondary"
             :on-click (fn []
                         (set! (. (.getElementById js/document "google-Autocomplete") -value))
                         (swap! !st assoc
                                :invalidate true
                                :invalidateMarker true
                                :srchLat nil
                                :srchLng nil
                                ))
             }
            "Reset"
            [cancel]]]
          ]]
        [mui/grid
         {:container true
          :direction "row"
          :spacing 1
          :alignItems "flex-end"
          }

         ;map
         [mui/grid
          {:item true
           :xs 12}
          [maps-element/map-home !st]
          ]

         ]
        ]
       ;;list
       [mui/grid
        {:item true
         :lg 3
         :md 5
         :xs 12}

        [mui/grid
         {:container true
          :direction "row"
          :justifyContent "flex-start"
          :alignItems "flex-end"
          :spacing 1
          }

         [mui/grid
          {:item true
           :md 2
           :xs 3}
          [select-all !st all]]


         [mui/grid
          {:item true
           :md 4
           :xs 4}
          [:div {:style #js {:width "120px" :margin "20px 0 0 10px" :display "inline-block"  }}
           (selected-chip !st)]
          ]

         [mui/grid
          {:item true
           :height 500
           :xs 12
           :sm 12
           }
          [mui/paper
           [:div
            (if-not @!loaded?
              [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."]
              [mui/paper
               (if (empty? @!elems)
                 [mui/paper [:h3 "Keine Ergebnisse gefunden!"]]
                 [small-toe-table/autoSizer-table !st]
                 )])]]]

         ]]


       ]
      )))


(defn get-it []
  (let [!st (r/cursor vstate/app-state [:toe-map :map-search-state])
        !loaded? (r/cursor !st [:loaded])
        !search (r/cursor !st [:search])
        !address-marker (r/cursor !st [:address-marker])
        !filter (r/cursor !st [:filter])]
    (when (not @!loaded?) (update-list !st !address-marker !search !filter))
    [render !st !loaded?]))

;[mui/paper
; {:style {:height "200px" :backgroundImage "repeating-linear-gradient(45deg,white 0%,white 6%, #c2a183 6%,#c2a183 12%, white 12%)"}}
; [:h1 "Komponente derzeit deaktiviert (kommt mit Einsatz-Verwaltung)"]]
